import { useRef, useState, useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { TABLE_VIEW, SORT_KEY_PROJECT_NAME } from './project-summary-helper';

export const useProjects = ({
  page, pageSize = 10, view = TABLE_VIEW, isValidCustomer, sortCriteria
}) => {
  // @TODO remove page number state (solve delete scenario when user already navigated multiple pages)
  const { svocID } = useThdCustomer();

  const [pageNumbers, setPageNumber] = useState([]);

  const {
    data, error, loading, refetch, client
  } = useDataModel('projects', {
    variables: {
      page: page || 1,
      pageSize,
      accountId: svocID,
      filter: [],
      sort: sortCriteria,
      skipNumberOfItems: view === TABLE_VIEW,
      skipImages: view === TABLE_VIEW,
    },
    ssr: false,
    skip: (!svocID) || !isValidCustomer,
    context: { withAuth: true }
  });

  useEffect(() => {
    if (!pageNumbers.includes(page)) {
      setPageNumber([...pageNumbers, page]);
    }
  }, [page]);

  const { projects: projectsResponse } = data || {};

  let projects = projectsResponse?.projects ? projectsResponse?.projects : [];

  const refetchProjects = async ({ page: pageNo }) => {
    const loadedPages = pageNumbers.filter((pg) => pg >= pageNo && pg !== page);
    const clearPromises = loadedPages.map((pgNo) => {
      return client.cache.evict({
        id: 'ROOT_QUERY',
        fieldName: 'projects',
        args: { page: pgNo, pageSize }
      });
    });
    await Promise.all(clearPromises);
    await client.cache.gc();
    refetch({ page });
  };

  function getTotalPages() {
    const quotient = Math.floor(projectsResponse?.totalProjects / pageSize);
    if (projectsResponse?.totalProjects % pageSize !== 0) {
      return quotient + 1;
    }
    return quotient;
  }

  return {
    pagination: {
      pageSize: projectsResponse?.pageSize,
      totalResults: projectsResponse?.totalProjects,
      totalPages: getTotalPages(),
      hasMore: projectsResponse?.totalProjects > pageSize * projectsResponse?.page
    },
    projects,
    error,
    loading: loading || typeof data === 'undefined',
    refetchProjects
  };
};
